const MiniCheckEditor = {
  props: ['value'],
  model: { event: 'change' },
  methods: {
    onChange (e) {
      this.$emit('change', e.target.checked);
    }
  },
  render (h) {
    return h('input', {
      domProps: {
        checked: this.value,
        type: 'checkbox'
      },
      on: {
        change: this.onChange,
        click: (e) => this.$emit('click', e)
      }
    })
  }
}

export default {
  install: function (Vue) {
    Vue.component('mini-check-editor', MiniCheckEditor)
  }
}